module.exports = __webpack_public_path__ + "assets/icon-button-details.47484f16.svg";